import Select from "react-select";
import { useEffect, useState } from "react";
import axios from "axios";
import {
  Box,
  Card,
  CardContent,
  Checkbox,
  Grid2,
  Typography,
} from "@mui/material";
import Swal from "sweetalert2";
import BASEURL from "../../../../pages/Utils/Baseurl.js";
import MaterialButton from "../../../../components/MaterialButton";
import DashboardLayout from "../../../../layoutcontainers/DashboardLayout/index.js";
import ConfirmationDialog from "../../../../components/Dialog/ConfirmationDialog";
import MaterialBox from "../../../../components/MaterialBox/index.js";
import MaterialSelect from "../../../../components/MasterSelect/index.js";
import MaterialTypography from "../../../../components/MaterialTypography/index.js";
import RoleSkeleton from "./RoleSkelton.jsx";
import { useLoading } from "../../../../context/LodingContext.jsx";

const allrolepermission = `
 query GetRolePermissionByRoleId($roleId: ID!) {
    getRolePermissionByRoleId(roleId: $roleId) {
      data {
        id
        role {
          id
        }
        component {
          componentName
          id
          module {
            moduleName
            id
            app {
              appName
              id
            }
          }
        }
        canAccess
      }
      success
      error
      message
    }
  }
`;

const updaterolepermission = `mutation UpdateRolesPermission($input: RolesPermissionUpdateInput!) {
  updateRolesPermission(input: $input) {
    success
    message
  }
}`;

const RolePermission = () => {
  const [tenants, settenants] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [role, setrole] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [allRole, setAllRole] = useState("");
  const [options, setoptions] = useState([]);
  const [selectedcomponent, setselectedcomponent] = useState([]);
  const [selectedModules, setSelectedModules] = useState({});
  const { setCirleLoading } = useLoading();

  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    showConfirm: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });

  const [initialValues, setinitialvalues] = useState({
    input: {
      roleId: "",
      appMerge: [
        {
          componentId: [],
          canAccess: [],
        },
      ],
    },
  });

  const processData = (apiData) => {
    const groupedData = {};

    apiData.forEach((item) => {
      const { module, componentName, id } = item;

      setinitialvalues((prev) => ({
        ...prev,
        input: {
          ...prev.input,
          appMerge: [
            {
              componentId: [...prev.input.appMerge[0].componentId, id],
              canAccess: [...prev.input.appMerge[0].canAccess, false],
            },
          ],
        },
      }));

      if (!groupedData[module?.app?.appName]) {
        groupedData[module?.app?.appName] = {
          appId: module?.app?.id,
          modules: {},
        };
      }

      if (!groupedData[module?.app?.appName].modules[module?.moduleName]) {
        groupedData[module?.app?.appName].modules[module?.moduleName] = {
          moduleId: module?.id,
          components: [],
        };
      }

      groupedData[module?.app?.appName].modules[
        module?.moduleName
      ].components.push({
        componentId: id,
        componentName: componentName,
      });
    });

    return Object.entries(groupedData).map(([appName, appData]) => ({
      appName,
      appId: appData.appId,
      modules: Object.entries(appData.modules).map(
        ([moduleName, moduleData]) => ({
          moduleName,
          moduleId: moduleData.moduleId,
          components: moduleData.components,
        })
      ),
    }));
  };

  const handlecheckstatus = (id) => {
    if (selectedcomponent.includes(id)) {
      setselectedcomponent((prev) => prev.filter((comp) => comp !== id));
    } else {
      setselectedcomponent((prev) => [...prev, id]);
    }
  };

  const handleCheckAll = () => {
    const allComponentIds = [];
    filteredData.forEach((app) => {
      app.modules.forEach((module) => {
        module.components.forEach((component) => {
          allComponentIds.push(component.componentId);
        });
      });
    });
    const isAllSelected = allComponentIds.every((id) =>
      selectedcomponent.includes(id)
    );
    if (isAllSelected) setselectedcomponent([]);
    else setselectedcomponent(allComponentIds);
  };

  const handleModuleCheck = (moduleName, components) => {
    const componentIds = components.map((c) => c.componentId);
    const allSelected = componentIds.every((id) =>
      selectedcomponent.includes(id)
    );
    if (allSelected) {
      setselectedcomponent((prev) =>
        prev.filter((id) => !componentIds.includes(id))
      );
    } else {
      setselectedcomponent((prev) => [...new Set([...prev, ...componentIds])]);
    }
  };

  const isModuleChecked = (components) => {
    return components.every((c) => selectedcomponent.includes(c.componentId));
  };

  const getroledata = async () => {
    const query = `query{ allRoles{ data{ id role description } } }`;
    try {
      const response = await axios.post(
        BASEURL,
        { query },
        {
          headers: { "Content-Type": "application/json" },
        }
      );
      const filterdata = response.data.data.allRoles[0].data.filter(
        (item) => item?.role !== "admin"
      );
      setrole(filterdata);
    } catch (error) {
      console.error("error:", error);
    }
  };

  useEffect(() => {
    getroledata();
  }, []);

  useEffect(() => {
    const fetchrole = async () => {
      const getallroles = `query allComponent { allComponents { data { id componentName module { id moduleName app { id appName } } } success error message } }`;
      try {
        const response = await axios.post(
          BASEURL,
          {
            query: getallroles,
            variables: { id: 1 },
          },
          {
            headers: { "Content-Type": "application/json" },
          }
        );
        const filter = processData(response?.data?.data?.allComponents?.data);
        setFilteredData(filter);
      } catch (error) {
        console.error(error);
      }
    };
    fetchrole();
  }, []);

  useEffect(() => {
    const fetchallroles = async () => {
      setIsLoading(true);
      try {
        const response = await axios.post(
          BASEURL,
          {
            query: allrolepermission,
            variables: { roleId: allRole.value },
          },
          {
            headers: { "Content-Type": "application/json" },
          }
        );
        if (response.data.data.getRolePermissionByRoleId.data) {
          const processedarray =
            response.data.data.getRolePermissionByRoleId.data.filter(
              (component) => component.canAccess
            );
          const choosedcomponents = processedarray.map(
            (component) => component.component.id
          );
          setselectedcomponent(choosedcomponents);
        } else {
          setselectedcomponent([]);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setIsLoading(false);
      }
    };
    if (allRole) fetchallroles();
  }, [allRole]);

  const handlesubmit = () => {
    // setConfirmationDialog({
    //   open: true,
    //   title: "Confirmation",
    //   message: "Are you sure you want to submit your details?",
    //   showCancel: true,
    //   showConfirm: true,
    //   onConfirm: () => onAddRoll(),
    //   onCancel: () => setConfirmationDialog({ ...confirmationDialog, open: false }),
    // });

    Swal.fire({
      position: "top",
      icon: "question",
      title: "Are you sure you want to submit your details?",
      showConfirmButton: true,
      showCancelButton: true,
    }).then((res) => {
      if (res?.isConfirmed) {
        onAddRoll();
      }
    });
  };

  const onAddRoll = async () => {
    const updatedinitialvalues = { ...initialValues };
    updatedinitialvalues.input.roleId = allRole?.value;
    setCirleLoading(true);
    try {
      const response = await axios.post(
        BASEURL,
        {
          query: updaterolepermission,
          variables: updatedinitialvalues,
        },
        {
          headers: { "Content-Type": "application/json" },
        }
      );
      Swal.fire({
        position: "center",
        icon: response?.data?.data?.updateRolesPermission?.success
          ? "success"
          : "error",
        title: response?.data?.data?.updateRolesPermission?.message,
        showConfirmButton: false,
        timer: 2500,
      });
      setConfirmationDialog({ ...confirmationDialog, open: false });
    } catch (err) {
      console.error(err);
    } finally {
      setCirleLoading(false);
    }
  };

  useEffect(() => {
    if (selectedcomponent) {
      const indextoupdate = selectedcomponent.map((component) =>
        initialValues.input.appMerge[0].componentId.indexOf(component)
      );
      const duplicatecanaccess = [...initialValues.input.appMerge[0].canAccess];
      const updatedcanaccess = duplicatecanaccess.map((canaccess, index) =>
        indextoupdate.includes(index) ? true : false
      );
      setinitialvalues((prev) => ({
        ...prev,
        input: {
          ...prev.input,
          appMerge: [
            {
              componentId: [...prev.input.appMerge[0].componentId],
              canAccess: updatedcanaccess,
            },
          ],
        },
      }));
    }
  }, [selectedcomponent]);

  const handleChanges = (e) => setAllRole(e);

  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog {...confirmationDialog} />
      )}
      <Box sx={{ padding: "10px" }}>
        <Box sx={{ width: "50%", marginBottom: "15px" }}>
          <MaterialBox lineHeight={0} display="inline-block">
            <MaterialTypography
              component="label"
              variant="caption"
              fontWeight="bold"
            >
              Role Name <span style={{ color: "red" }}>*</span>
            </MaterialTypography>
          </MaterialBox>
          <MaterialSelect
            name="role"
            value={allRole}
            onChange={handleChanges}
            options={role?.map((role) => ({
              value: role.id,
              label: role.role,
            }))}
            isClearable
          />
        </Box>

        <Box>
          {allRole?.value && (
            <Box>
              <Box
                sx={{   
                  display: "flex",
                  justifyContent: "end",
                  padding: "0px 70px",
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Typography
                    sx={{
                      fontWeight: "600",
                      color: "#424242",
                      marginRight: "10px",
                      fontSize: "16px",
                    }}
                  >
                    Select All
                  </Typography>
                  <Checkbox
                    onChange={handleCheckAll}
                    checked={
                      filteredData.length > 0 &&
                      filteredData
                        .flatMap((app) =>
                          app.modules.flatMap((m) =>
                            m.components.map((c) => c.componentId)
                          )
                        )
                        .every((id) => selectedcomponent.includes(id))
                    }
                    sx={{
                      color: "#424242",
                      "&.Mui-checked": { color: "#1976d2" },
                      "& .MuiSvgIcon-root": {
                        fontSize: "18px",
                        border: "1px solid #424242",
                        borderRadius: "4px",
                      },
                    }}
                  />
                </Box>
              </Box>
              {filteredData.map((app, appInd) => (
                <CardContent key  ={appInd}>
                  <Grid2 container spacing={2}>
                    {app.modules.map((module, moduleInd) => (
                      <Grid2 key={moduleInd} size={{ lg: 4, xs: 5, sm: 3 }}>
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          <Typography
                            sx={{
                              fontWeight: "600",
                              color: "#424242",
                              fontSize: "16px",
                              marginRight: "10px",
                            }}
                          >
                            {module.moduleName}
                          </Typography>
                          <Checkbox
                            onChange={() =>
                              handleModuleCheck(
                                module.moduleName,
                                module.components
                              )
                            }
                            checked={isModuleChecked(module.components)}
                            sx={{
                              color: "#424242",
                              "&.Mui-checked": { color: "#1976d2" },
                              "& .MuiSvgIcon-root": {
                                fontSize: "18px",
                                border: "1px solid #424242",
                                borderRadius: "4px",
                              },
                            }}
                          />
                        </Box>
                        {module.components.map((component, compInd) => (
                          <Box
                            key={compInd}
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              margin: "10px 0px",
                            }}
                          >
                            <Checkbox
                              checked={selectedcomponent.includes(
                                component.componentId
                              )}
                              onChange={() =>
                                handlecheckstatus(component.componentId)
                              }
                              sx={{
                                color: "#424242",
                                "&.Mui-checked": { color: "#1976d2" },
                                "& .MuiSvgIcon-root": {
                                  fontSize: "18px",
                                  border: "1px solid #424242",
                                  borderRadius: "4px",
                                },
                              }}
                            />
                            <Typography
                              variant="body1"
                              sx={{ fontSize: "15px" }}
                            >
                              {component.componentName}
                            </Typography>
                          </Box>
                        ))}
                      </Grid2>
                    ))}
                  </Grid2>
                </CardContent>
              ))}
            </Box>
          )}
          <Box sx={{ display: "flex", justifyContent: "end" }}>
            {allRole?.value && (
              <MaterialButton
                sx={{ m: 2 }}
                variant="gradient"
                color="dark"
                onClick={handlesubmit}
              >
                Submit
              </MaterialButton>
            )}
          </Box>
        </Box>
      </Box>
    </DashboardLayout>
  );
};

export default RolePermission;
